import { Component, Input, OnInit } from '@angular/core';
import { ParametrosMaestro, AccesoEstado } from 'src/app/models/common/enumModel';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { IFilterAccesoModel } from 'src/app/models/interfaces/accesos/IFilterAccesoModel';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { SedeService } from 'src/app/services/sede/sede.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-acceso-filtros-busqueda',
  templateUrl: './acceso-filtros-busqueda.component.html',
  styleUrls: ['./acceso-filtros-busqueda.component.css']
})
export class AccesoFiltrosBusquedaComponent implements OnInit {
  @Input() modelFilter!: IFilterAccesoModel;
  listaSedes: ISedeModel[] = new Array<SedeModel>();
  paramsEstados!: ParametroModel[];
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();

  constructor(
    private sedeService: SedeService,
    private parametroService: ParametroService,
    private storage: StorageService
  ) { 
    this.listaSedes = new Array<SedeModel>();
  }

  ngOnInit(): void {
    let usuario = this.storage.getCurrentUser();
    this.listaCompanias = usuario.companias;
    this.companiaChanged();
    this.parametroService
      .getDetalles(ParametrosMaestro.ESTADO_ACCESO_PERSONA)
      .subscribe((data) => {
        this.paramsEstados = data.items.filter(result => result.idParametroDetalle != AccesoEstado.PENDIENTE);
      });
  }

  companiaChanged() {

    this.listaSedes = [];
    this.modelFilter.sedes = [];
    let filterSede: IFilterSedeModel = new FilterSedeModel();
    filterSede.companias.push(this.modelFilter.idCompania);

    this.sedeService
      .getList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
      });
  }

  addDays(currentDate: Date, days : number): Date{
    currentDate.setDate(currentDate.getDate() + days);
    return currentDate;
  }

  keyPressNumberOnly(event: any) {
    const pattern = /^[0-9]*$/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  
}
